<div #loader class="loading-state-container"></div>
